import { RouteName } from "@/app/routing/routing";
import { isInteractionsPageEnabled } from "@/app/utils/Utils";
import { STORE } from "@/store";
import { InteractionsServiceConstants, SERVICE } from "@agentx/agentx-services";
import { Router } from "@uuip/unified-ui-platform";
import { html, nothing } from "lit-html";
import style from "./QueueStatsDetailsBlock.scss";
const QueueStatsDetailsBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="queue-detail">
        ${STORE.app.featureFlags.isQueueStatsDetailViewEnabled
            ? html `<div class="frame">
              <div class="queue-detail-box">
                <agentx-wc-queue-stats-detail
                  .interactionsStore=${STORE.interactions}
                  queueId=${STORE.agentContact.getSelectedQueueId}
                  .isDarkMode=${STORE.app.darkMode}
                  orgId=${STORE.agent.orgId}
                  .isRTDIntialized=${STORE.app.isRTDIntialized}
                  ?isInteractionsPageEnabled=${isInteractionsPageEnabled()}
                  @header-close-clicked=${() => {
                STORE.agentContact.selectedQueueStatsQueueChange("");
                STORE.layout.setRouterViewClasses({ expanded: false });
            }}
                  @navigate-to-interaction=${(e) => {
                STORE.routing.setExtraRouteParams(RouteName.Interactions, {
                    interactionId: e.detail.interactionId,
                    tab: InteractionsServiceConstants.QueryType.Queued,
                    filters: {
                        queue: { type: "equals", filter: e.detail.queue }
                    }
                });
                STORE.routing.navigate(RouteName.Interactions);
            }}
                >
                  <span slot="agents-grid-slot">
                    <agentx-wc-queue-stats-agents-grid
                      queueId=${STORE.agentContact.getSelectedQueueId}
                      orgId=${STORE.agent.orgId}
                      .queueStatsStore=${STORE.queueStatsStore}
                      .isRTDIntialized=${STORE.app.isRTDIntialized}
                      .isDarkMode=${STORE.app.darkMode}
                      .isAgentQueueManagementEnabled=${STORE.app.featureFlags.isAgentQueueManagementEnabled}
                      @queue-stats-agents-view-event=${(e) => {
                SERVICE.telemetry.track(SERVICE.telemetry.TELEM_EVENT.QUEUE_STATS_AGENT_LINK_CLICKED);
                STORE.agent.setFilterAgent(e.detail.data.agentId);
                STORE.routing.navigate(RouteName.TPW);
            }}
                    ></agentx-wc-queue-stats-agents-grid>
                  </span>
                </agentx-wc-queue-stats-detail>
              </div>
            </div>`
            : nothing}
      </div>
    `,
        styles: style
    });
};
export default QueueStatsDetailsBlock;
